module.exports = __webpack_public_path__ + "static/media/Play_Now_Button@3x.dd452531.png";